import { weChatSetShare } from './share';

import { isAndroid, isIOS, isWeChatDevTools } from '@/modules/detector';
import { storage } from '@/modules/storage';
import { loggerInfo } from '@/modules/logger';

import { WeChat } from '@/interface';
import { checkWeChat, weChatSDKSign } from './config';

import { HsUtilEntryUrl } from '@/data/storage';
import { LogModule } from '@/data/config';

export * from './miniprogram';
export { weChatLoadSDK, getWeChatJSBridge, weChatSDKSign } from './config';

/**
 * 预先设置入口地址，提供给签名使用
 * 微信分享记录
 * 一般放在进入到页面后调用
 * 可在 main.js
 * IOS 微信才调用该方法
 */

export const weChatSetByEntryUrl = () => {
  if (isAndroid() || !isWeChatDevTools()) return;

  /** 非微信开发者工具 并且在IOS 微信 */
  if (!isWeChatDevTools() && isIOS()) {
    loggerInfo('微信平台 且 IOS', LogModule.WeChat);
    storage.session.set(HsUtilEntryUrl, window.location.href.split('#')[0]);
  }
};

/**
 * 微信分享功能
 * @returns
 */
type IWXOptions = Omit<WeChat.IWXShareOptions, 'imgUrl'> & {
  debug?: boolean;
  jsApiList?: WeChat.jsApiListType[];
  reqUrl?: string; // 必填
  url?: string;
  imgUrl?: string;
  wechatUrl?: string;
  isNeedGetStorage?: boolean;
};

export const weChatShare = async (options: IWXOptions): Promise<unknown> => {
  // 验证是否在微信浏览器
  const { valid } = checkWeChat('非微信浏览器打开或没有传递options参数');
  if (!valid || !options)
    return {
      success: false,
      message: '非微信浏览器打开或没有传递options参数',
    };

  try {
    const {
      debug,
      wechatUrl,
      jsApiList = [
        WeChat.jsApiListType.updateAppMessageShareData,
        WeChat.jsApiListType.updateTimelineShareData,
        WeChat.jsApiListType.onMenuShareTimeline,
        WeChat.jsApiListType.onMenuShareAppMessage,
        WeChat.jsApiListType.onMenuShareQQ,
        WeChat.jsApiListType.onMenuShareWeibo,
        WeChat.jsApiListType.onMenuShareQZone,
      ],
      isNeedGetStorage = true,
      ...shareOptions
    } = options;

    const url =
      options?.url ??
      (isIOS() && !isWeChatDevTools() && isNeedGetStorage && storage.session.get(HsUtilEntryUrl)
        ? storage.session.get(HsUtilEntryUrl)
        : window.location.href.split('#')[0]);

    // 触发签名方法
    await weChatSDKSign({
      wechatUrl,
      reqUrl: options?.reqUrl,
      url,
      jsApiList,
      debug,
    });

    // 设置微信分享配置
    return weChatSetShare(
      Object.assign(
        {
          imgUrl: 'https://r.hstong.com/v2/commons/images/h5/share_default.png',
        },
        shareOptions
      ),
      jsApiList
    );
  } catch (e) {
    console.warn(e);
    return {
      success: false,
      data: e,
    };
  }
};
